import React from "react";
import { AlertTriangle, Check, Info } from "lucide-react";
import {
  AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent,
  AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle,
} from "@/components/ui/alert-dialog";

// Confirmación para acciones que NO se pueden deshacer.
//
// Por qué existe: `window.confirm` corta el texto largo, no tiene jerarquía (el aviso
// que duele pesa lo mismo que el que tranquiliza), pone el botón peligroso en azul de
// "aceptar" y lo enmarca con un "localhost dice" que la gente cierra sin leer. Para
// borrar un proveedor con sus productos eso no basta.
//
// `puntos`: [{ texto, tono }] con tono "malo" (lo que se pierde), "bueno" (lo que
// sobrevive) o "info" (contexto). El orden que llega es el orden que se pinta.
const ICONO = {
  malo: { Icon: AlertTriangle, clase: "text-destructive" },
  bueno: { Icon: Check, clase: "text-emerald-600 dark:text-emerald-400" },
  info: { Icon: Info, clase: "text-brand-stone" },
};

export default function ConfirmDialog({
  open, onOpenChange, title, intro, puntos = [], confirmLabel, cancelLabel,
  onConfirm, busy = false,
}) {
  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent className="max-h-[85vh] overflow-y-auto">
        <AlertDialogHeader>
          <AlertDialogTitle className="text-destructive">{title}</AlertDialogTitle>
          {intro && (
            <AlertDialogDescription className="text-base text-foreground">
              {intro}
            </AlertDialogDescription>
          )}
        </AlertDialogHeader>

        {puntos.length > 0 && (
          <ul className="space-y-2.5 text-sm">
            {puntos.map((p, i) => {
              const { Icon, clase } = ICONO[p.tono] || ICONO.info;
              return (
                <li key={i} className="flex items-start gap-2.5">
                  <Icon size={16} className={`mt-0.5 shrink-0 ${clase}`} />
                  <span className={p.tono === "malo" ? "font-semibold" : "text-brand-stone"}>{p.texto}</span>
                </li>
              );
            })}
          </ul>
        )}

        <AlertDialogFooter>
          {/* Cancelar es el foco inicial: la salida segura es la que está bajo el dedo. */}
          <AlertDialogCancel autoFocus disabled={busy}>{cancelLabel}</AlertDialogCancel>
          <AlertDialogAction
            disabled={busy}
            onClick={(e) => { e.preventDefault(); onConfirm(); }}
            className="bg-destructive text-destructive-foreground hover:bg-destructive/90"
            data-testid="confirm-dialog-accept"
          >
            {confirmLabel}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
